import React from 'react'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'


function Option(props) {
    const style = {
        border: "1px solid lightgrey",
        borderRadius: "2px",
        padding: "6px",
        marginBottom: "6px",
        transition: "background-color 0.2s ease",
        color: props.top1 ? 'white' : 'black',
        backgroundColor: '#E7DCDA',
        backgroundImage: 'none', // to prevent styling inheritance
        fontWeight: props.top1 ? 'bold' : '500',
        '&:hover': {backgroundColor: '#B2292D', color: 'white'},
        width: "100%",
        '&.Mui-disabled': {
            color: 'black',
            opacity: 1
        },
        textTransform: 'none',
        display: 'flex',
        fontWeight: props.top1 ? 'bold' : '500',
        fontFamily: 'Montserrat',
    }

    return (
        <Button 
            sx={style}
            disabled={true}
        >
            <Grid container sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                <Grid item xs={2} sx={{color: '#B2292D'}}>
                    {props.option.percent}%
                </Grid>
                <Grid item xs={10}>
                    <p>{props.option.content}</p>
                </Grid>

            </Grid>
        </Button>
    )
}

export default Option